import { Component } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";

import { Formik, Field, Form, ErrorMessage } from "formik";
import ProductService from "../services/product.service";
import BrandService from "../services/brand.service";
import StyleService from "../services/style.service";
import ShopifyService from "../services/shopify.service";
import IColorMetaobject from '../types/colorMetaobject.type';
type Props = {};

const ROW_COLUMN_SIZE_META = "product.metafields.shopify.size";
const HEADER_COLUMN_SIZE = "Size (product.metafields.shopify.size)";
const ROW_COLUMN_COLOR_META = "product.metafields.shopify.color-pattern";
const HEADER_COLUMN_COLOR = "Color (product.metafields.shopify.color-pattern)";
const HEADER_COLUMN_COLOR_NAME = "colorName";
const ROW_COLUMN_COLOR_VALUE = "Color";
const HEADER_COLUMN_SIZE_NAME = "sizeName";
const ROW_COLUMN_SIZE_VALUE = "Size";
const HEADER_COLUMN_STATUS = 'Status';
const PRODUCT_STATUS_DRAFT = 'draft';
const CSV_ROW_ITEM_SEPARATOR = ',';
const CSV_ROW_SEPARATOR = '\n';
const SHOULD_ADD_HYPHEN_IN_SIZE = false;
const LIMITED_SIZE_ARRAY = ['M','L','XL','2XL'];
const SSACTIVEWEAR_CDN = 'https://cdn.ssactivewear.com/';
type State = {
  content: string,
  csvInformation: string,
  productArray:Array<ProductDTO>,
  productItemArray:Array<ProductCompactViewDTO>,
  loading: boolean,
  message: string,
  isAdmin:boolean,
  CSVData:string,
  showDownloadLink:boolean,
  sizeArray: string[],
  colorArray: string[],
  filterSizeValue:string,
  searchItem:SearchItem
}
interface SearchItem {
  partNumber: string,
  styleId: string
}
interface ProductCompactViewDTO {
  partNumber: string,
  title: string
}
interface ProductDTO {
  sku: string,
    gtin: string,
    title:string,
    description:string,
    skuID_Master: number,
    yourSku: string,
    styleID: number,
    brandName: string,
    brandID: string,
    styleName: string,
    colorName: string,
    colorCode: string,
    colorPriceCodeName: string,
    colorGroup: string,
    colorGroupName: string,
    colorFamilyID: string,
    colorFamily: string,
    baseCategoryID: string,
    colorSwatchImage: string,
    colorSwatchTextColor: string,
    colorFrontImage: string,
    colorSideImage: string,
    colorBackImage: string,
    colorDirectSideImage: string,
    colorOnModelFrontImage: string,
    colorOnModelSideImage: string,
    colorOnModelBackImage: string,
    color1: string,
    color2: string,
    sizeName: string,
    sizeCode: string,
    sizeOrder: string,
    sizePriceCodeName: string,
    caseQty: number,
    unitWeight: string,
    mapPrice: number,
    piecePrice: number,
    dozenPrice: number,
    casePrice: number,
    salePrice: number,
    customerPrice: number,
    noeRetailing: boolean,
    caseWeight: number,
    caseWidth: number,
    caseLength: number,
    caseHeight: number,
    polyPackQty: number,
    qty: number
}

export default class BoardAdmin extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadBrands = this.loadBrands.bind(this);
    this.loadStyles = this.loadStyles.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
    this.findAllProducts = this.findAllProducts.bind(this);
    this.clearBrands = this.clearBrands.bind(this);
    this.clearStyles = this.clearStyles.bind(this);
    this.clearProducts = this.clearProducts.bind(this);
    this.downloadCSVData = this.downloadCSVData.bind(this);
    this.handleFilterSizeChange = this.handleFilterSizeChange.bind(this);

    this.state = {
      content: "",
      csvInformation:"",
      loading: false,
      productArray:[],
      productItemArray:[],
      message: "",
      isAdmin:false,
      CSVData:"",
      showDownloadLink:false,
      filterSizeValue:'',
      searchItem:{partNumber:'',styleId:''},
      sizeArray: [],
      colorArray: [],
    };
  }

  componentDidMount() {
    UserService.getAdminBoard().then(
      
      response => {
        console.log('[content]'+response.data);
        this.setState({
          content: '',
          csvInformation:"",
          isAdmin:true,
        });
      },
      error => {
        console.log('[error.content]'+error.response.data);
        this.setState({
          isAdmin:false,
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        });

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }

  loadBrands(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false
    });
    BrandService.fetch().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  loadStyles(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false
    });
    StyleService.fetch().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  loadProducts(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false,
      filterSizeValue:''
    });
    ProductService.fetchAll().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  findAllProducts(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      productItemArray:[],
      CSVData:'',
      showDownloadLink:false,
      filterSizeValue:''
    });
    ProductService.findAll().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        let message = response.data && response.data.length>0?'':'No record found.';
        this.setState({
          productItemArray:response.data,
          content:message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  clearBrands(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false,
      filterSizeValue:''
    });
    BrandService.clear().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  clearStyles(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false,
      filterSizeValue:''
    });
    StyleService.clear().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
  clearProducts(){
    this.setState({
      loading: true,
      searchItem:{partNumber:'',styleId:''},
      productArray:[],
      CSVData:'',
      showDownloadLink:false,
      filterSizeValue:''
    });
    ProductService.clear().then(
      (response) => {
        console.log('[response]');
        console.log(response.data);
        
        this.setState({
          content:""+response.data.message,
          loading: false,
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }
//clearProducts
  handleSubmit(formValue: { partnumber: string; style: string;shouldfetch:boolean }) {
      const { partnumber, style,shouldfetch } = formValue;
  
      this.setState({
        message: "",
        loading: true,
        CSVData:'',
        searchItem:{partNumber:partnumber,styleId:style},
        productArray:[],
        productItemArray:[],
        showDownloadLink:false,
      filterSizeValue:''
      });
  
  
      ProductService.fetchById(partnumber, style, shouldfetch).then(
        (response) => {
          console.log('[response]');
          let colorArrayForDisplay:string[] = [];
          let colorGroupArrayForDisplay:string[] = [];
          //let colorGroupArray:string[] = [];
          let colorArray:string[] = [];
          let sizeArray:string[] = [];
          let sizeArrayForDisplay:string[] = [];
          console.log(response.data);
          if(response.data && response.data.length>0){
          let variantCount = response.data.length;
          for (let element of response.data) {
            colorArray.push(this.getHandleName(element.colorName));
            colorArrayForDisplay.push(element.colorName+"|"+element.color1);
            colorGroupArrayForDisplay.push(element.colorGroupName);
            sizeArray.push(this.getValidSize(element.sizeName));
            sizeArrayForDisplay.push(element.sizeName);
          }
        const uniqueColorArray = colorArray.filter((value, index, self) => self.indexOf(value) === index);
        const uniqueColorArrayForDisplay = colorArrayForDisplay.filter((value, index, self) => self.indexOf(value) === index);
        const uniqueSizeArray = sizeArray.filter((value, index, self) => self.indexOf(value) === index);
        const uniqueSizeArrayForDisplay = sizeArrayForDisplay.filter((value, index, self) => self.indexOf(value) === index);
        const uniqueColorGroupArrayForDisplay = colorGroupArrayForDisplay.filter((value, index, self) => self.indexOf(value) === index);
        const maxVariantCount = uniqueColorArray.length*uniqueSizeArray.length;
        const shouldReduceSizeArray = maxVariantCount > 100;
        let filteredSizeArray = [...uniqueSizeArray];
        if(shouldReduceSizeArray){
          filteredSizeArray = uniqueSizeArray.filter(item => LIMITED_SIZE_ARRAY.includes(item));
        }
        
        this.upsertColorMetaObjectsInBulk(this.generateShopifyPayloadDTOArrayForColors(uniqueColorArrayForDisplay));
        
        
        const contentText = "<b>Colors:</b> "+uniqueColorArrayForDisplay.join(',')+"<br/><br/><b>Base Colors:</b> "+uniqueColorGroupArrayForDisplay+"<br/><br/><b>Sizes:</b> "+uniqueSizeArrayForDisplay+"<br/><br/><b>Default Filtered Sizes:</b>"+filteredSizeArray+"<br/><br/><b>Variant Count:</b> "+variantCount+"<br/><br/><b>Max Variant Count:</b>"+maxVariantCount;
        
        let csvDataArray = this.jsonToCSVArray(response.data,filteredSizeArray,uniqueColorArray);
        const csvInformationText = "<br/><br/><b>Total Variants in file after size filtering:</b>"+csvDataArray.length;
        const csvData = csvDataArray.join(CSV_ROW_SEPARATOR);
          this.setState({
            productArray: response.data,
            content:contentText,
            csvInformation:csvInformationText,
            loading: false,
            CSVData:csvData,
            showDownloadLink:true,
            filterSizeValue:'',
            sizeArray:filteredSizeArray,
            colorArray:uniqueColorArray,
          });
        }else {
          this.setState({
            loading: false,
            message: "No product found with given information",
            searchItem:{partNumber:'',styleId:''},
            productArray:[],
            CSVData:'',
            showDownloadLink:false,
            filterSizeValue:'',
            sizeArray:[],
            colorArray:[],
          });
        }
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
          this.setState({
            loading: false,
            message: resMessage,
            searchItem:{partNumber:'',styleId:''},
            productArray:[],
            CSVData:'',
            showDownloadLink:false,
            filterSizeValue:''
          });
        }
      );
    }
    handleFilterSizeChange(e:React.ChangeEvent<HTMLInputElement>){
      let sizeFilter = e.target.value;
      console.log('[handleFilterSizeChange]'+sizeFilter);
      let sizeFilterArray = sizeFilter.split(',');      
      this.rebuildCSVContent(sizeFilterArray);
    }
    downloadCSVData(){
      this.triggerDownloadFile(this.state.CSVData,this.getFileName(this.state.searchItem.partNumber,this.state.searchItem.styleId));
    }
    rebuildCSVContent(sizeFilterArray:string[]){
      console.log('[handleFilterSizeChange]'+sizeFilterArray);
      let csvDataArray = this.jsonToCSVArray(this.state.productArray,sizeFilterArray,this.state.colorArray);
        const csvInformationText = "<br/><br/><b>Total Variants in file after size filtering:</b>"+csvDataArray.length;
        const csvData = csvDataArray.join(CSV_ROW_SEPARATOR);
        this.setState({
          csvInformation:csvInformationText,
          loading: false,
          CSVData:csvData,
          sizeArray: sizeFilterArray,
          showDownloadLink:true
        });
    }
    triggerDownloadFile(csvData:string,fileName:string){
      // Create a CSV file and allow the user to download it
      let blob = new Blob([csvData], { type: 'text/csv' });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
    generateShopifyPayloadDTOArrayForColors(colorArray:string[]){
      let jsonArray:IColorMetaobject[] = [];
      for (let i = 0; i < colorArray.length; i++) {
        let item = colorArray[i];
        let itemArray:string[] = item.split('|');
        let hexColor = itemArray[1];
        let colorName = itemArray[0];
        let handleName = this.getHandleName(colorName);
        jsonArray.push({
          "colorLabel":colorName,
          "hexColor":hexColor,
          "handleName":handleName
        });
      }
      return jsonArray;
    }
    generateShopifyPayloadForColors(colorArray:string[]){
      let jsonArray:string[] = [];
      for (let i = 0; i < colorArray.length; i++) {
        let item = colorArray[i];
        let itemArray:string[] = item.split('|');
        let hexColor = itemArray[1];
        let colorName = itemArray[0];
        let handleName = this.getHandleName(colorName);
        let jsonItem = `{
  "handle": {
    "type": "shopify--color-pattern",
    "handle": "${handleName}"
  },
  "metaobject": {
    "fields": [
      {
        "key": "label",
        "value": "${colorName}"
      },
      {
        "key": "color",
        "value": "${hexColor}"
      },
      {
          "key": "color_taxonomy_reference",
          "value": "[\\"gid://shopify/TaxonomyValue/4\\"]"
      },
      {
          "key": "pattern_taxonomy_reference",
          "value": "gid://shopify/TaxonomyValue/2874"
      }

    ]
  }
}
        `;
        jsonArray.push(jsonItem.replaceAll('\n',''));
      }
      console.log(jsonArray[1]);
      return jsonArray;
    }
    upsertColorMetaObjectsInBulk(arrayOfPayload:IColorMetaobject[]){
      let arrayOfPayloadFirst:IColorMetaobject[] = [];
      arrayOfPayloadFirst.push(arrayOfPayload[2]);
      console.log('[arrayOfPayloadFirst]');
      console.log(arrayOfPayloadFirst);
      this.callToShopifyMetaobjectInBulk(arrayOfPayload);
    }
    callToShopifyMetaobjectInBulk(requestPayload:IColorMetaobject[]){
      ShopifyService.upsertMetaobjectInBulk(requestPayload).then(
        (response) => {
          console.log('[response]');
          console.log(response.data);
        },
        error => {
          console.log('[resMessage]');
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
            console.log(resMessage);
        }
      );
    }
    callToShopifyMetaobject(requestPayload:string){
      ShopifyService.upsertMetaobject(requestPayload).then(
        (response) => {
          console.log('[response]');
          console.log(response.data);
        },
        error => {
          console.log('[resMessage]');
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
            console.log(resMessage);
        }
      );
    }

    getFileName(partnumber?:string,style?:string){
      if(partnumber){
        return 'DataImport_PartNumber_'+partnumber+'_'+Date.now()+'.csv';
      } else if(style){
        return 'DataImport_Style_'+style+'_'+Date.now()+'.csv';
      }
      return 'DataImport_'+Date.now()+'.csv';
    }
    getHandleName(str:string) {
      let newstring = str.replaceAll(" ","-");
      newstring = newstring.replace(/[^A-Za-z0-9-]/g, '');
      return newstring.toLowerCase();
    }
    getAbsoluteURLForImage(imageRelativePath:string) {
      return SSACTIVEWEAR_CDN+imageRelativePath;
    }
    getValidSize(str:string) {
      const firstChar = str.charAt(0);
      if(SHOULD_ADD_HYPHEN_IN_SIZE && this.isNumber(firstChar)){
        return firstChar+"-"+str.substring(1);
      }
      return str;
    }
    isNumber(value: string | number) {
      if (!isNaN(Number(value))) {
        return true;
      } 
      return false;
    }
    getHeaderElementsAsArray(productDTOKeys:Array<keyof ProductDTO>){
      //can be aded: Variant SKU
      let columnNames:string[] = [];
      columnNames.push('Handle');
      for (let i = 0; i < productDTOKeys.length; i++) {
        let colName = productDTOKeys[i];
        if(colName===HEADER_COLUMN_SIZE_NAME){
          columnNames.push('Option1 Name');
          columnNames.push('Option1 Value');
          columnNames.push('Option1 Linked To');
        } else if(colName===HEADER_COLUMN_COLOR_NAME){
          columnNames.push('Option2 Name');
          columnNames.push('Option2 Value');
          columnNames.push('Option2 Linked To');
        } else if(colName==='piecePrice'){
          columnNames.push('Variant Price');
        } else if(colName==='brandName'){
          columnNames.push('Vendor');
          columnNames.push('Product Category');
        } else if(colName==='colorFrontImage'){
          columnNames.push('Variant Image');
        } else if(colName==='description'){
          columnNames.push('Body (HTML)');
        } else if(colName==='title'){
          columnNames.push('Title');
        } else if(colName==='unitWeight'){
          columnNames.push('Variant Grams');
        } else{
          columnNames.push(productDTOKeys[i]);
        }
      }
      columnNames.push(HEADER_COLUMN_STATUS);
      columnNames.push(HEADER_COLUMN_SIZE);
      columnNames.push(HEADER_COLUMN_COLOR);
      return columnNames;
    }
    getSafeCellvalue(cellValue:string|number|boolean){
      let newCellValue = cellValue.toString().replace(/"/g, '""');
      if (newCellValue && newCellValue.search(/("|,|\n)/g) >= 0) {
        return `"${newCellValue}"`;
      }
      return newCellValue;
    }
    jsonToCSVArray(productArray:Array<ProductDTO>,allSizes:string[],allColors:string[]) {
      const productDTOKeys:Array<keyof ProductDTO> = Object.keys(productArray[0]) as Array<keyof ProductDTO>;
      let arrayOfRows:string[]= [];
      arrayOfRows.push(this.getHeaderElementsAsArray(productDTOKeys).join(CSV_ROW_ITEM_SEPARATOR));
      const productArrayLength = productArray.length;
      let isFirstRowAdded = false;
      for (let pIndx = 0; pIndx < productArrayLength; pIndx++) {
        let currentProductDto = productArray[pIndx];
        let sizeName = currentProductDto.sizeName;
        if(allSizes.indexOf(sizeName)>=0){
        let arrayOfRowItems:string[]= [];
        arrayOfRowItems.push(this.getHandleName(currentProductDto.title));
        for (let kIndx = 0; kIndx < productDTOKeys.length; kIndx++) {
          let colName = productDTOKeys[kIndx];
          if(colName===HEADER_COLUMN_SIZE_NAME){
            arrayOfRowItems.push(!isFirstRowAdded?ROW_COLUMN_SIZE_VALUE :'');
            arrayOfRowItems.push(this.getValidSize(currentProductDto[colName]).toLowerCase());
            arrayOfRowItems.push(!isFirstRowAdded?ROW_COLUMN_SIZE_META :'');
          } else if(colName===HEADER_COLUMN_COLOR_NAME){
            arrayOfRowItems.push(!isFirstRowAdded?ROW_COLUMN_COLOR_VALUE :'');
            arrayOfRowItems.push(this.getHandleName(currentProductDto[colName]));
            arrayOfRowItems.push(!isFirstRowAdded?ROW_COLUMN_COLOR_META :'');
          } else if (colName.endsWith('Image')){
            arrayOfRowItems.push(this.getAbsoluteURLForImage(this.getSafeCellvalue(currentProductDto[colName])));
          } else if(colName==='brandName'){
            arrayOfRowItems.push(this.getSafeCellvalue(currentProductDto[colName]));
            arrayOfRowItems.push('Apparel & Accessories > Clothing > Clothing Tops > T-Shirts');
          } else if(colName==='unitWeight'){
            let weightInOunces = this.getSafeCellvalue(currentProductDto[colName]);
            const weightInGrams = parseFloat(weightInOunces)*28.34952;// parseFloat(weightInGramsStr)*1000;
            arrayOfRowItems.push(weightInGrams+'');
          }
          else{
            arrayOfRowItems.push(this.getSafeCellvalue(currentProductDto[colName]));
          }
        }
        if(!isFirstRowAdded){
          arrayOfRowItems.push(PRODUCT_STATUS_DRAFT);
          arrayOfRowItems.push(allSizes.join('; ').toLocaleLowerCase());
          arrayOfRowItems.push(allColors.join('; ').toLocaleLowerCase());
          isFirstRowAdded = true;
        } else {
          arrayOfRowItems.push('');
          arrayOfRowItems.push('');
          arrayOfRowItems.push('');
        }
        arrayOfRows.push(arrayOfRowItems.join(CSV_ROW_ITEM_SEPARATOR));
      }
      }
        return arrayOfRows;
    }
    

  render() {
    const { loading, message, productArray,productItemArray } = this.state;
    const firstProduct = productArray.length>0? productArray[0]: {} as ProductDTO;
    const productTableHeader:Array<keyof ProductDTO> = (productArray.length>0 && firstProduct)? Object.keys(firstProduct) as Array<keyof ProductDTO>: [];
    const firstProductCompactView = productItemArray.length>0? productItemArray[0]: {} as ProductCompactViewDTO;
    const productCompactViewTableHeader:Array<keyof ProductCompactViewDTO> = (productItemArray.length>0 && firstProductCompactView)? Object.keys(firstProductCompactView) as Array<keyof ProductCompactViewDTO>: [];
    const noOfExistingProducts = productItemArray.length;
    const initialValues = {
      partnumber: "",
      style: "",
      shouldfetch:false,
    };
    return (
      
      <div className="container">
        
        
        <div className="">
        {this.state.isAdmin && (
          <div>
            <div className="p-5 mb-4 bg-body-tertiary rounded-3">
            <div className="btn-group d-inline me-2">
              <button type="button" onClick={this.loadBrands} className="btn btn-primary">Load Brands</button>
              <button type="button" onClick={this.loadStyles} className="btn btn-primary">Load Styles</button>
              <button type="button" onClick={this.loadProducts} className="btn btn-primary">Load Products</button>
              
            </div>

            <div className="btn-group d-inline me-2">
            <button type="button" onClick={this.findAllProducts} className="btn btn-secondary">List All Existing Products</button>
            </div>
            <div className="btn-group d-inline">
            <button type="button" onClick={this.clearBrands} className="btn btn-secondary">Clear Brands</button>
              <button type="button" onClick={this.clearStyles} className="btn btn-secondary">Clear Styles</button>
              <button type="button" onClick={this.clearProducts} className="btn btn-secondary">Clear Products</button>
            </div>
            <h6 className="mt-3">Note: Load Brands and Styles first before Loading all products. To check if product data is loaded already, click on 'List All Existing Products'.</h6>
            
            </div>
          <Formik
                      initialValues={initialValues}
                      onSubmit={this.handleSubmit}
                    >
                      <Form>
                        <div className="mb-3">
                          <label htmlFor="partnumber" className="form-label">Product part number (Item # on ssactivewear website i.e. 64467)</label>
                          <Field name="partnumber" type="text" className="form-control" />
                          <ErrorMessage
                            name="partnumber"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
          
                        <div className="form-group d-none">
                          <label htmlFor="style" className="form-label">Style Id</label>
                          <Field name="style" type="text" className="form-control" />
                          <ErrorMessage
                            name="style"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="d-inline" htmlFor="shouldfetch">
                          <Field name="shouldfetch" type="checkbox" className="d-inline me-2" />
                          
                          Load product?</label>
                          <label className="d-block">Note: check 'Load product' only if you don't find the product without checking it first. If checked, it will get the products from api and save it in database and query those products. If unchecked, it will query the products in our existing database</label>
                          <ErrorMessage
                            name="shouldfetch"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
          
                        <div className="mb-3">
                          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                            {loading && (
                              <span className="spinner-border spinner-border-sm"></span>
                            )}
                            <span>Submit</span>
                          </button>
                        </div>
          
                        {message && (
                          <div className="mb-3">
                            <div className="alert alert-danger" role="alert">
                              {message}
                            </div>
                          </div>
                        )}
                        
                      </Form>
                    </Formik>
                    {this.state.content && this.state.content.length>0 && (<header className="p-5 mb-4 bg-body-tertiary rounded-3">
          
          <div dangerouslySetInnerHTML={{__html: this.state.content}} />
          {this.state.csvInformation && this.state.csvInformation.length>0 && (
          <div dangerouslySetInnerHTML={{__html: this.state.csvInformation}} />
          )}
          <div className="d-block mt-2">
          {this.state.showDownloadLink && (
            <div className="mb-3">
            <label aria-label="inputFilterSizes" className="form-label">Filter Sizes</label>
            <input type="text" onBlur={this.handleFilterSizeChange} className="form-control" id="inputFilterSizes" aria-describedby="emailHelp"></input>
            <div id="inputFilterSizesHelp" className="form-text">Please provide sizes as comma seperated value i.e. S,M,L</div>
          </div>
          )}
        {this.state.showDownloadLink && (
                    <div className="btn-group">
              <button type="button" onClick={this.downloadCSVData} className="btn btn-success">Download File</button>
              </div>
  )}
  </div>
        </header>)}
        <div className="mb-2 mt-2">
        
  {productItemArray && productItemArray.length > 0 && (
    <div>
    <div className="mb-2">
      No of records: {noOfExistingProducts}
    </div>
        <table>
         <thead>
            <tr>
              {productCompactViewTableHeader.map((headerItem, idx) => (
                <th key={idx}>{headerItem}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {productItemArray.map((item:any, ix) => (
              <tr key={ix}>
                {productCompactViewTableHeader.map((key) => (
                  
                  <td>
                    {key.toString() === 'description' ? (
                    <div dangerouslySetInnerHTML={{__html: item[key]}} />
                  ) : (
                    <span>{item[key]}</span>
                  )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
  </div>
  <div className="d-none mb-2 mt-2">
  {productArray && productArray.length > 0 && (
        <table>
         <thead>
            <tr>
              {productTableHeader.map((headerItem, idx) => (
                <th key={idx}>{headerItem}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {productArray.map((item:any, ix) => (
              <tr key={ix}>
                {productTableHeader.map((key) => (
                  
                  <td>
                    {key.toString() === 'description' ? (
                    <div dangerouslySetInnerHTML={{__html: item[key]}} />
                  ) : (
                    <span>{item[key]}</span>
                  )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
  </div>
                    </div>
                    )}
        </div>
      </div>
    );
  }
}
